import axios from 'axios';

const baseurl = 'http://localhost:5207'

const api = axios.create({
    //baseURL: 'http://localhost:5207',
});

export default api;